<template>
  <article class="t-left pcinner">
    <loading :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="fullPage"></loading>
    <div class="entry-content">
      <ItemList v-bind:ItemList="itemList" v-bind:ItemTotal="itemTotal" />
      <nav v-if="isLoading == false" class="pagerbox">
        <paginate
          v-model="itemPage"
          :page-count="itemPageTotal"
          :page-range="2"
          :margin-pages="1"
          :prev-text="'<'"
          :next-text="'>'"
          :click-handler="clickCallback"
          :container-class="'pagination'"
          :page-class="'pagerL'"
          :prev-class="'pagerL'"
          :next-class="'pagerL'"
          >
        </paginate>
      </nav>
    </div>
  </article>
</template>

<script>
import axios from 'axios'
import ItemList from '@/components/ItemList.vue'
import Paginate from 'vuejs-paginate';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import config from '../mixins/config'

export default {
  name: 'List',
  components: {
    ItemList,
    Paginate,
    Loading
  },
  data () {
    return {
      detail: [],
      itemList: [],
      brandCode:'',
      itemTotal: 0,
      itemPageTotal: 0,
      itemPage: 1,
      isLoading: false,
      fullPage: true,
      searchWord: [],
      brand:'all',
      category:'all',
      gender:'all',
    }
  },
  mixins: [ config ],
  created () {
    this.initialize()
    this.setParams(this.$route)
    .then(() => {
      this.setupPage(this.$route)
    })
  },
  watch: {
  },
  beforeRouteUpdate(to, from, next) {
    this.initialize()
    this.setParams(to)
    .then(() => {
      this.setupPage(to)
    })

    next();
  },
  methods: {
    initialize() {
      this.refresh();
    },
    refresh() {
      this.detail = {}
      this.itemList = []
      this.itemTotal = 0
      this.itemPageTotal = 0
      this.itemPage = 1
      this.isLoading = false
      this.searchWord = []
    },
    async setParams(route){
      // Loading
      this.isLoading = true
      //cateogry
      if(route.params.brand){
        await axios.get('https://app3.sportsstyle.net/brands/' + route.params.brand)
        .then((res) => {
          this.brand = res.data.id
          this.searchWord.push(res.data.name_full)
        })
      }
    },
    setupPage(route) {
      //cateogry
      if(route.params.category && route.params.category != 'all'){
        this.category = this.categories[route.params.category].id
        this.searchWord.push(this.categories[route.params.category].name)
      }
      //gender
      if(route.params.gender && route.params.gender != 'all'){
        this.gender = this.genders[route.params.gender].id
        this.searchWord.push(this.genders[route.params.gender].name)
      }
      if(route.query.page){
        this.itemPage = parseInt(route.query.page)
      }
      if(this.searchWord.length > 0){
        this.$store.commit('chageSearchWord', this.searchWord.join(" "))
      }

      let url = 'https://app3.sportsstyle.net/items/list/' + this.brand + '/' + this.gender + '/' + this.category + '/?page=' + this.itemPage
      axios.get(url)
      .then((res) => {
        let title = ''
        if(this.searchWord.length > 0){
          title += this.searchWord.join(" ")
        }
        title += 'アイテム一覧ページ'
        title += ' (' + this.itemPage + 'ページ目)'

        let description = title + 'です。'
        this.setHeader(title, description, true)
        this.itemList = res.data.list
        this.itemTotal = res.data.item_total
        this.itemPageTotal = res.data.page_total
        this.isLoading = false
      })
      .catch(() =>{
        console.log('item list not found')
       // this.$router.push({ name: "404"})
      })
    },
    clickCallback(pageNum) {
      this.setPaginate(this.$router.name, this.$router.params, pageNum)
    },
  }
}

</script>
